export default __webpack_public_path__ + "static/media/IBMEye.6700d124.svg";